import { Grid } from '@forgeglobal/design-framework';
import cs from 'classnames';
import useStyles from './style';

interface DialogBodyProps {
  type: 'form' | 'message';
  children: React.ReactNode;
}

const DialogBody = ({ type, children }: DialogBodyProps) => {
  const classes = useStyles({});

  const [containerClass, bodyClass] = (() => {
    switch (type) {
      case 'message':
        return [
          classes.messageContainer,
          cs(classes.messageBody, classes.dialogBody),
        ];
      case 'form':
        return ['', classes.dialogBody];
    }
  })();

  return (
    <Grid container justifyContent="center" className={containerClass}>
      <Grid item className={bodyClass}>
        {children}
      </Grid>
    </Grid>
  );
};

export default DialogBody;
